import { useEffect } from "react"
import Flex from "@/components/flex"
import HeaderWrapperDesktop from "../header-wrapper-desktop"
import { analysisStore } from "@/routes/apt/[apt_code]/analysis/analysis-store"
import { langStore } from "@/stores/lang-store"
import AptHeaderContent from "../apt-header-content"
import SearchButton from "@/components/buttons/search-button"
import DropdownDong from "../_parts/dropdown-dong"
import { useState } from "react"
import { headerBundle } from "./analysis-header-const"

const AnalysisHeaderDesktop = () => {
  const { dongs, originDongs, selectedDong, setSelectedDong, dongBadgesMap } = analysisStore()

  const { lang } = langStore()
  const [tempDong, setTempDong] = useState(selectedDong)

  useEffect(() => {
    analysisStore.getState().dongMapping(originDongs)
  }, [lang, originDongs])

  const handleChange = (id) => {
    setTempDong(id)
  }
  const handleConfirmSearch = () => {
    setSelectedDong(tempDong)
  }

  return (
    <HeaderWrapperDesktop>
      <AptHeaderContent label={headerBundle.caption[lang]}>
        <Flex className="items-center ml-auto" gap={8}>
          <span className="text-sm text-gray-400">{headerBundle.selectDong[lang]}</span>
          <DropdownDong
            options={dongs}
            onChange={(id) => handleChange(id)}
            value={tempDong}
            unitStatusMap={dongBadgesMap}
          />
          <SearchButton onClick={handleConfirmSearch} lang={lang} />
        </Flex>
      </AptHeaderContent>
    </HeaderWrapperDesktop>
  )
}

export default AnalysisHeaderDesktop
